module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-700.e45478d4.woff2";